module.exports = __webpack_public_path__ + "img/ic-jcb-no-color.ed6bd48e.svg";